const TRANSACTION_HEADER = "X-One-Time-Link-Transaction";
const TRANSACTION_ID_PATTERN = /^[A-Za-z0-9_-]{22}$/;

export function currentLinkTransactionConfig(config = {}) {
  const transactionId = window.location.hash.slice(1);
  if (!TRANSACTION_ID_PATTERN.test(transactionId)) return config;

  return {
    ...config,
    headers: {
      ...(config.headers || {}),
      [TRANSACTION_HEADER]: transactionId,
    },
  };
}
